module.exports = __webpack_public_path__ + "static/media/techsauce.828ed92d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pictures/techsauce.png
// module id = 179
// module chunks = 0